module.exports = __webpack_public_path__ + "media/images/allianz-banner-ad-4f4abf95e748bb2c1dbc97190b3992c6.jpg";